import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { EnvironmentThemeProvider } from '@codex-brightworld/themes';

const StyledTooltip = styled.div`
  background: #ffefef;
  color: #213038;
  font-size: 14px;
  padding: 10px 16px;
  margin-bottom: 15px;
  border-radius: 8px;
  width: ${(props) => (
    props.isFullWidth ? '100%' : 'auto'
  )}
`;

export const AddToBasketErrorMessage = ({
  failedToUpdateBasket,
  pleaseTryAgain,
  isFullWidth
}) => (
  <EnvironmentThemeProvider>
    <StyledTooltip isFullWidth={isFullWidth}>
      <>
        { failedToUpdateBasket }
        {' '}
        -
        {' '}
        { pleaseTryAgain }
        <br />
      </>
    </StyledTooltip>
  </EnvironmentThemeProvider>
);

AddToBasketErrorMessage.propTypes = {
  failedToUpdateBasket: PropTypes.string.isRequired,
  pleaseTryAgain: PropTypes.string.isRequired,
  isFullWidth: PropTypes.bool
};

AddToBasketErrorMessage.defaultProps = {
  isFullWidth: false
};
